module.exports = __webpack_public_path__ + "img/5-2-chef.0e31f5b0.jpg";